import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import Select from 'react-select';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import { ExaminationForm, ExaminationType } from "../../../constants/nutriconstant"
import CalcUtils from "../../../helpers/CalcUltils"
import { cloneDeep, isEmpty } from "lodash"
import { toast } from "react-toastify"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import { useHistory } from "react-router"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductType } from "../ProductList"

const ProductEditUnit = (props: any) => {
    const { data, setData, type, onlyView, branch, closeModal } = props
    const [unit, setUnit] = useState<any>(props?.unit);
    const handleUnitAdd = () => {
        const newDetailtiveUser = {
            name: "",
            quantity_conversion:"",
        };
        setUnit([...unit, newDetailtiveUser]);
    };

    useEffect(()=>{
        if(props?.unit?.length === 0){
            setUnit([{
                name: "",
                quantity_conversion:"",
            }])
        }else{
            setUnit(props?.unit)
        }
    },[data])

    const handleUnitUpdate = (dataDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(unit);
        newDetailtiveUser[index] = dataDetail;
        setUnit(newDetailtiveUser);
    };

    const handleUnitRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(unit);
        const atributesRemove = newDetailtiveUser[index]
        if(atributesRemove?.id){
            toast.warning("Không thể xóa đơn vị quy đổi này")
            return
        }
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser = [{
            name: "",
            quantity_conversion:"",
        }]
        setUnit(newDetailtiveUser);
    };

    const handleUnitSubmit = ()=>{
        props?.setUnit(unit)
    }

    return (
        <CardBody className='p-0' style={{width:600}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">Đơn vị quy đổi</h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body p-4 pt-2 pb-2">
                {
                    unit?.map((item:any, index:number) => (
                        <UnitItem 
                            detailIndex={index} 
                            data={item}
                            onChangeData={(dataDetail: any) =>
                                handleUnitUpdate(dataDetail, index)
                            }
                            type={type}
                            onlyView={onlyView}
                            handleRemoveData={() => handleUnitRemove(index)}
                            handleAddData={() => handleUnitAdd()}
                            detail={unit}
                        />
                    ))
                }
            </div>
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        handleUnitSubmit() 
                        closeModal()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
        </CardBody>
    )
}

const UnitItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData} = props
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }
    
    return (
        <Row key={detailIndex}>
            <Col md={5} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Tên đơn vị</Label>
                    <InputGroup>
                        <Input disabled={data?.id} type="text" value={data?.name} onChange={(e: any) => handleChangeData(e)} name="name" placeholder="Nhập tên đơn vị..." />
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col md={5} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Số lượng quy đổi</Label>
                    <NumberFormat 
                        onChange={(e: any) => handleChangeData({ target: { name: 'quantity_conversion', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'quantity_conversion'} type={'text'} className="form-control" 
                        value={type === 'view' && !data?.quantity_conversion ? '---': data?.quantity_conversion}
                        placeholder={(type=='view' && !data?.quantity_conversion) ? "---" : "Nhập số lượng quy đổi..."} thousandSeparator={true} 
                    />
                </FormGroup>
            </Col>
            {!onlyView &&
            <Col md={2} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label></Label>
                    <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                    {
                        detail?.length == detailIndex+1 &&
                        <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>
                    }
                </FormGroup>
            </Col>}
        </Row>
    )
}

export default ProductEditUnit